import { render, staticRenderFns } from "./taxAccidentalList.vue?vue&type=template&id=50b1fa76&scoped=true&"
import script from "./taxAccidentalList.vue?vue&type=script&lang=js&"
export * from "./taxAccidentalList.vue?vue&type=script&lang=js&"
import style0 from "./taxAccidentalList.vue?vue&type=style&index=0&id=50b1fa76&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1fa76",
  null
  
)

export default component.exports